var _path, _path2;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogoEliteIslamicIcon = function SvgLogoEliteIslamicIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7675 28.2133C20.7675 28.2133 0.571413 27.4965 0.0123309 39.4371C-0.00225385 39.7434 0.245687 39.9983 0.551966 39.9983H27.6293C27.9189 39.9983 28.1982 39.9535 28.4601 39.8708L34.9687 28.2128H20.7675V28.2133Z",
    fill: "#FFF6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.062 0.40081C28.6363 0.137745 28.1453 0 27.6456 0H0.540176C0.241999 0 0 0.241999 0 0.540176V14.2039C0 14.4362 0.149088 14.6415 0.36894 14.716C10.9672 18.2936 20.2863 25.1214 25.963 35.0352C26.8494 36.5834 27.6478 38.2072 28.3479 39.9055C28.5974 39.8385 28.833 39.7375 29.049 39.6078C29.0679 39.5959 29.0868 39.5841 29.1057 39.5722C35.6451 35.5111 40 28.2647 40 20.0005C40 11.7364 35.6262 4.45645 29.062 0.40081Z",
    fill: "#00CD52"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoEliteIslamicIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-elite-islamic-icon.6f6503b1.svg";
export { ForwardRef as ReactComponent };